import type { Resource } from '../../';
export const forms_field_saveToAddressBook: Resource = {"default":"Save to my Address Book"};
